import Smartphones from 'Counterparties/Suppliers/views/SelectableSuppliersView/containers/Smartphones'
import Tablets from 'Counterparties/Suppliers/views/SelectableSuppliersView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SelectableSuppliersView = getCurrentDeviceView(Smartphones, Tablets)

export default SelectableSuppliersView
